import React from 'react'
import {Redirect, Route} from 'react-router-dom'
import {withAuth} from './hoc/Auth'

export const PrivateRout = withAuth(
    ({component: RouteComponent, isAuthorized, forcedPasswordChange, requires2FASetup, ...rest}) => {

        return (
            <Route
                {...rest}
                render={routeProps => {
                    if (!isAuthorized) {
                        return <Redirect to={"/login"}/>;
                    }

                    // Если требуется смена пароля или настройка 2FA - разрешаем только /profile
                    if (forcedPasswordChange || requires2FASetup) {
                        const pathname = routeProps.location && routeProps.location.pathname;
                        if (pathname === "/profile") {
                            return <RouteComponent {...routeProps} />;
                        }
                        return <Redirect to={"/profile"}/>;
                    }

                    return <RouteComponent {...routeProps} />;
                }}
            />
        )
    })



// WEBPACK FOOTER //
// ./src/PrivateRoute.js